export default __webpack_public_path__ + "static/media/img-doc.4a389020.svg";